import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Breadcrumbs from "../component/breadcrumbs";
import CustomHelmet from "../component/CustomHelmet";
import Form from "../component/Form";
import FormInput from "../component/FormInput";
import Intro from "../component/Intro";
import BaseContainer from "../component/layout/base-container";

export default function StartSurvey() {
  const [tan, setTan] = useState("");
  const [tanStatus, setTanStatus] = useState();

  useEffect(() => {
    async function check_if_exists() {
      if (tan.length >= 6) {
        const tan_number = parseInt(tan);
        try {
          const resp = await axios.get(
            `${process.env.REACT_APP_BASE_URL}survey/${tan_number}/`
          );
          if (resp.status === 200) setTanStatus("valid");
        } catch (err) {
          if (err.response.status === 404) setTanStatus("invalid");
        }
      }
    }
    check_if_exists();
  }, [tan]);

  useEffect(() => {
    if (tan.length < 6) {
      setTanStatus(undefined);
    }
  }, [tan]);

  return (
    <>
      <CustomHelmet pageTitle="Umfrage" />
      <Breadcrumbs
        listItems={[
          { name: "Home", url: "/" },
          { name: "Umfrage", url: "/umfrage" },
        ]}
      />
      <BaseContainer>
        <Intro title={"Umfrage ausfüllen"} />
        <p className="mb-8">
          Mithilfe des zugewiesenen Zugangscodes kann die Umfrage ausgefüllt
          werden. Bitte Zugangscode eingeben.
        </p>
        <Form>
          <FormInput
            label="Zugangscode"
            value={tan}
            onChange={(e) => setTan(e.target.value.replaceAll("[^0-9.]", ""))}
            description={
              tanStatus
                ? tanStatus === "valid"
                  ? "Sie können Ihre Umfrage jetzt starten."
                  : "Dieser Zugangscode stimmt leider nicht, bitte korrigieren Sie ihn."
                : `${tan.length} / 6`
            }
          />
          <div className="FormButtons mb-8">
            <Link
              disabled={tanStatus !== "valid"}
              className="Button color-primary size-large"
              style={{
                marginRight: "unset",
                marginLeft: "auto",
                ...(tanStatus !== "valid" && {
                  backgroundColor: "rgba(var(--c-grey-light),1)",
                  color: "rgba(var(--c-black),0.6)",
                }),
              }}
              to={`/umfrage/${tan}`}
            >
              <span className="Button--inner">Umfrage starten</span>
            </Link>
          </div>
        </Form>
      </BaseContainer>
    </>
  );
}
